import { setConsentAsker } from "./consent.js";
let loading;
export function installConsentDialog() {
	setConsentAsker((key, warning) => {
		if (!loading) loading = import(__RVM.consentJs).catch((error) => { loading = null; throw error; });
		return loading.then((module) => module.showConsent(key, warning)).catch(() => { alert("Couldn't load the warning. Reload the page and try again."); return false; });
	});
}
